// @ is an alias to /src
import Sidebar from "@/components/sidebar";
import Navbar from "@/components/navbar";

export default {
    name: 'consultation',

    data() {
        return {
            moments_value: null,
            types_value: null,
            moments_error: null,
            types_error: null,
            prix: 15000
        };
    },

    components: {
        Sidebar,
        Navbar
        //MicroModules
    },
    props: [],

    computed: {

        moments() {
            return this.$store.getters['momentsConsultations']
        },
        types() {
            return this.$store.getters['typesConsultations']
        }
    },
    mounted() {
        this.$store.dispatch("getMomentsConsultations");
        this.$store.dispatch("getTypesConsultations");
        //this.$refs.multiSelect.select();

    },
    methods: {
        pickMoment(moment) {
            console.log(moment.id);
        },
        pickType(type) {
            console.log(type.id);
        },
        momentValidate() {
            if (!this.moments_value) {
                this.moments_error = true
                console.log("errormom")
                return false
            }
            this.moments_error = false
            return true;
        },
        typeValidate() {
            if (!this.types_value) {
                this.types_error = true
                console.log("errorty")
                return false
            }
            this.types_error = false
            return true;
        },
        onSubmit() {
            if (this.momentValidate() && this.typeValidate()) {
                return true
            }

        }
    }
};